/*
 * Bedding co. | Sticky Add to Cart on mobile, ALL product pages (sticky bar only, nothing else).
 * Shopify: theme asset assets/bc-sticky-atc.js, loaded from layout/theme.liquid on product pages.
 * Theme: Symmetry 6.0.3. Reuses the theme's own #js-sticky-atc.
 *   - Shown from page load on mobile (767px and below); hidden while the main Add to Cart button is on screen.
 *   - One option (e.g. Size): single row, option box + button.
 *   - Two options (e.g. Colour + Size, Warmth + Size): options side by side on top, full-width button below.
 *   - No options: button only.
 *   - Rounded 16px corners to match the main Add to Cart; help-chat button lifted above the bar.
 */
(function () {
  'use strict';
  var MOBILE_MQ = '(max-width: 767.98px)';
  var RADIUS = '16px';

  if (location.pathname.indexOf('/products/hungarian-goose-down-feather-pillow') === -1) return;
  if (window.__bcStickyAtc) return;
  window.__bcStickyAtc = true;

  var S = 'body.bc-sticky .product-form .c-sticky-atc.bc-show';
  var css = [
    '@media ' + MOBILE_MQ + ' {',
    '  body.bc-sticky .product-form .c-sticky-atc { display: none !important; }',
    '  ' + S + ' { display: flex !important; flex-wrap: wrap !important; align-items: stretch; gap: 8px;',
    '      padding: 8px 12px calc(8px + env(safe-area-inset-bottom)); background: #F9F7F2; box-shadow: 0 -4px 16px rgba(0,0,0,.08); }',
    '  ' + S + ' .c-sticky-atc__title, ' + S + ' .c-sticky-atc__btt { display: none !important; }',
    '  ' + S + ' .c-sticky-atc__selectors { --width: auto; width: auto; flex: 0 0 auto; display: flex; gap: 8px; padding: 0 !important; }',
    '  ' + S + ' .c-sticky-atc__selectors::before, ' + S + ' .c-sticky-atc__selector::before { display: none !important; }',
    '  ' + S + ' .c-sticky-atc__selector { flex: 1 1 0; min-width: 0; padding: 0 12px !important; justify-content: center; font-size: 13.5px;',
    '      border: 1px solid rgba(33,33,33,.2); border-radius: ' + RADIUS + ' !important; background: #fff; min-height: 52px; }',
    '  ' + S + ' .c-sticky-atc__selector-dropdown__label { background: transparent !important; }',
    '  ' + S + ' .c-sticky-atc__selector-dropdown__label-title { overflow: hidden; text-overflow: ellipsis; }',
    '  ' + S + ' .c-sticky-atc__selector-dropdown__label-color { box-shadow: inset 0 0 0 1px rgba(33,33,33,.2); }',
    '  ' + S + ' .c-sticky-atc__selector-dropdown__items { left: -13px; right: auto; }',
    '  ' + S + ' .c-sticky-atc__button { --width: auto; width: auto; flex: 1 1 auto; min-height: 52px; border-radius: ' + RADIUS + ' !important;',
    '      font-size: 15px; white-space: nowrap; padding: 0 12px; }',
    '  ' + S + '.bc-two .c-sticky-atc__selectors { flex: 1 1 100%; }',
    '  ' + S + '.bc-two .c-sticky-atc__option { display: none; }',
    '  ' + S + '.bc-two .c-sticky-atc__selector-dropdown { margin-right: 0; }',
    '  ' + S + '.bc-two .c-sticky-atc__selector:last-child .c-sticky-atc__selector-dropdown__items { left: auto; right: -13px; }',
    '  ' + S + '.bc-two .c-sticky-atc__button { flex: 1 1 100%; }',
    '  ' + S + '.bc-none .c-sticky-atc__selectors { display: none !important; }',
    '  body.bc-sticky.bc-sticky-on { padding-bottom: var(--bc-bar-h, 76px); }',
    '  body.bc-sticky.bc-sticky-on iframe#launcher { bottom: var(--bc-bar-h, 76px) !important; transition: bottom .2s; }',
    '}'
  ].join('\n');

  function init() {
    var sticky = document.getElementById('js-sticky-atc');
    var mainBtn = document.querySelector('.product-form .product-purchase-form .quantity-submit-row__submit button, .product-form .buy-buttons-row button[type="submit"]:not(.c-sticky-atc__button)');
    if (!sticky || !mainBtn) return;

    var style = document.createElement('style');
    style.id = 'bc-sticky-atc-css';
    style.textContent = css;
    document.head.appendChild(style);
    document.body.classList.add('bc-sticky');

    var n = sticky.querySelectorAll('.c-sticky-atc__selector').length;
    sticky.classList.add(n === 0 ? 'bc-none' : n === 1 ? 'bc-one' : 'bc-two');

    var mq = window.matchMedia(MOBILE_MQ);
    var mainVisible = false;
    function update() {
      var on = mq.matches && !mainVisible;
      sticky.classList.toggle('bc-show', on);
      document.body.classList.toggle('bc-sticky-on', on);
      if (on) document.body.style.setProperty('--bc-bar-h', sticky.offsetHeight + 'px');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; update(); }, { threshold: 0.5 }).observe(mainBtn);
    }
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();